"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectListConverter_1 = require("../../core/conversions/DataObjectListConverter");

var MetadataHierarchyRowDTOConverter =
/*#__PURE__*/
function (_DataObjectListConver) {
  _inherits(MetadataHierarchyRowDTOConverter, _DataObjectListConver);

  function MetadataHierarchyRowDTOConverter() {
    _classCallCheck(this, MetadataHierarchyRowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(MetadataHierarchyRowDTOConverter).apply(this, arguments));
  }

  return MetadataHierarchyRowDTOConverter;
}(DataObjectListConverter_1.DataObjectListConverter);

exports.MetadataHierarchyRowDTOConverter = MetadataHierarchyRowDTOConverter;